import React from 'react';
import LogoGroup from './LogoGroup';
import { useI18n } from '@/i18n/I18nProvider';
import { useLogout } from '@/lib/hooks/useLogout';
import { UserCircleIcon, SignOutIcon, ListIcon, XIcon, HouseIcon, GlobeIcon } from '@/components/icons';
import { NotificationBell } from '../notifications';
import { Link, useNavigate } from 'react-router-dom';

const MobileHeader = () => {
  const { t, locale } = useI18n();
  const { logout } = useLogout();
  const navigate = useNavigate();

  return (
    <div className="header-mobile lg:hidden">
      <div className="header-top py-2">
        <div className="container">
          <div className="max-lg:flex max-lg:items-center justify-between">
            <LogoGroup />
            <div className="header-top-right">
              <div>
                <div className="flex items-center gap-3">
                  <NotificationBell onClick={() => navigate('/notifications')} />
                  <button
                    data-modal-target="openMenu"
                    data-modal-toggle="openMenu"
                    className="hamburger-icon text-aeblack-700"
                  >
                    <ListIcon></ListIcon>
                    <span className="sr-only">Toggle main menu</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="openMenu"
        tabIndex={-1}
        aria-hidden="true"
        className="responsive-menu !transform-none hidden [&_.main-navigation_.menu-item.active-page_a]:border-none [&_.accordion-active_svg]:rotate-180 max-lg:py-4 lg:hidden max-lg:bg-whitely-50 max-lg:fixed max-lg:inset-0 max-lg:w-full max-lg:[&_li_a]:w-full max-lg:[&_li_a]:py-2 max-lg:[&_.submenu-btn]:!absolute max-lg:[&_.submenu-btn]:end-0 max-lg:[&_.submenu-btn]:top-2 max-lg:[&_.submenu-btn]:w-6 max-lg:z-50 max-lg:flex-wrap max-lg:items-start max-lg:justify-start"
      >
        <div className="w-full">
          <div className="w-full max-lg:px-4 flex items-center justify-between gap-4 mb-4">
            <a href="#">
              <img src={locale === 'ar' ? '/moe-logo-ar.svg' : '/moe-logo-en.svg'} alt="logo" width={150} />
            </a>
            <div className="flex items-center gap-4">
              <button data-modal-hide="openMenu">
                <XIcon size={28} />
                <span className="sr-only">Close main menu</span>
              </button>
            </div>
          </div>

          <div className="max-lg:max-h-[calc(100vh_-_6.375rem)] max-lg:px-4 max-lg:overflow-auto">
            <nav className="main-navigation mb-4" aria-label="Main navigation">
              <div className="menu-main-menu-container">
                <ul id="responsive-header-collapse" data-accordion="collapse" className="menu nav-menu">
                  <li className="menu-item relative has-link-icon">
                    <Link to="/">
                      <HouseIcon></HouseIcon>
                      <span>{t.nav.home}</span>
                    </Link>
                  </li>

                  <li className="menu-item relative">
                    <Link to="/myapplications">
                      <span>{t.nav.myApplications}</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </nav>

            <div className="header-top-right">
              <div>
                <ul className="header-common-links">
                  <li>
                    <Link to="/profile" className="cursor-pointer">
                      <UserCircleIcon size={20} />
                      <span>{t.nav.profile}</span>
                    </Link>
                  </li>

                  <li>
                    <a onClick={logout} className="cursor-pointer">
                      <SignOutIcon size={20} />
                      <span>{t.logout}</span>
                    </a>
                  </li>
                  <li>
                    <a data-modal-target="modal-lang" data-modal-toggle="modal-lang">
                      <GlobeIcon></GlobeIcon>
                      <span>{t.common.switchLanguage}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;
